import type { ProductKey } from "@/lib/billing/entitlements";
import type { BundleTierId } from "@/lib/billing/bundle-entitlements";
import type {
  UpgradeQuoteSource,
  UpgradeQuoteTargetInterval,
} from "@/components/billing/UpgradeQuoteModal";

export type AppPromoCta =
  | { kind: "video_modal"; videoUrl: string; label: string }
  | { kind: "link"; href: string; label: string; external?: boolean }
  | {
      kind: "upgrade";
      href: string;
      label: string;
      targetTier: BundleTierId;
      targetInterval?: UpgradeQuoteTargetInterval;
      source?: UpgradeQuoteSource;
    };

export type AppPromoConfig = {
  id: string;
  entitlement: ProductKey;
  badgeText: string;
  strongText: string;
  restText?: string;
  cta: AppPromoCta;
};

export const WHALE_WATCH_PROMO: AppPromoConfig = {
  id: "whale-watch:v1",
  entitlement: "whale-watch",
  badgeText: "New",
  strongText: "Whale Watch is live.",
  restText: "Follow whale money today.",
  cta: {
    kind: "upgrade",
    href: "/pricing?product_type=Whale+Watch",
    label: "Unlock with Gold",
    targetTier: "gold",
    targetInterval: "monthly",
    source: "feature_gate",
  },
};
